// // Use $ instead of jQuery without replacing global $
(function ($) {
    //match height function for intro with col
    $('.intro-with-col .col-wrap .content-wrapper .text-box .text-content').matchHeight();
    $('.intro-with-col .col-wrap .content-wrapper .text-box .text-content h4').matchHeight();
})(jQuery);